module.exports = __webpack_public_path__ + "static/media/Lato-black.a7cae4d8.svg";